import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {CheckoutFooterComponent} from './checkout-footer.component';
import {GenericLinkModule} from '@spartacus/storefront';
import {SapLogoModule} from '../../layout/header/sap-logo/sap-logo.module';
import {FooterModule} from '../../layout/footer/footer.module';

@NgModule({
  declarations: [
    CheckoutFooterComponent
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutFooterNavigationComponent: {
          component: CheckoutFooterComponent,
        }
      }
    }),
    I18nModule,
    SapLogoModule,
    GenericLinkModule,
    FooterModule,
  ]
})
export class CheckoutFooterModule {
}
